/**
* In this file we handel the users Outcoming calls with popup screen
**/
import { Modal,Button } from 'react-bootstrap';
import ApiService from './../../services/ApiService';
import Socket from './../../services/SocketService';
import { convertS3privateToPublic } from './../../services/UtilsService';
import { useEffect,useState} from 'react';
const { connect } = require('twilio-video');

function OutgoingModal(props) {
	
	//Intial state declaration
  const [video,setVideo]=useState(false);
  const [isJoin,setJoin]=useState(false);
  const [userEnd,setUserEnd]=useState(false);
  const [isHold,setHold] = useState(false);
  const [missedCall,setMissedCall] = useState(false);
  const [room,setRoom]=useState({});
  const [access,setAccess]=useState({call:true,connect:false,end:false,isAudio:true,videoMute:true,audioMute:false});
  
  //Component initialize function
  useEffect(()=>{
	
	  //To check media device
	   navigator.mediaDevices?.enumerateDevices()
      .then((devices:any)=>{
        devices.forEach((device)=>{	
		    if(device.kind ==='videoinput'){
			   setVideo(true);
			}
		});
        });
		
		//To trigger the Hold call
       Socket.holdCall((data)=>{
		  holdCall(data);
	   });
	// eslint-disable-next-line
  },[]);
  
  //To make or connect call
  const makeCall=async()=>{
	 setAccess(access => ({ ...access, call:false,connect:true }));
	 var response= await ApiService.makeCall({receiver:props.id});
	  if(response.status===200){
	   Socket.joinCall(response.data.room);
	   connectRoom(response.data);
	   setAccess(access => ({ ...access, end: true, connect: false, call: false }));
	  }
  };
  
  //To cancel or end call
  const endCall=()=>{
	  if(room.participants.size===0){
		  Socket.closeIncomingCall({receiver:props.id,room:room.name});
	  }
	  room.disconnect();
	  setUserEnd(true);
  };
  
  //To close popup
  const closeModal=()=>{
	  if(Object.keys(room).length !==0 && room.participants.size!==0){
		  endCall();
	  }
	  props.handleClose();
  }
  
  /** 
  * To hold or unhold call the
  * @val pass the status of the call in Boolean value
  **/
  const holdCall=(val:any)=>{

    setHold(val);
	setRoom(prevRoom => {
    prevRoom.localParticipant.tracks.forEach((publications:any) => {
	     if(val===true){
		   publications.track.disable();
		 }else{
		    if(publications.kind==='video'){
			     access.videoMute?publications.track.disable():publications.track.enable();
			 }else if(publications.kind==='audio'){
			     access.audioMute?publications.track.disable():publications.track.enable();
			 }
		 }
	});
	 return prevRoom;
	});
  }
  
  /** 
  * To connect to call room
  * @data pass the twilio call token and Socket room name
  **/
  const connectRoom=(data)=>{
	  
      connect(data.token, {name: data.room,video:video,audio:true }).then(room => { 
	       setRoom(room);
	      //To show the local user video in screen
		   room.localParticipant.tracks.forEach((publications) => {
		       if(publications.kind==='video'){
			     publications.track.disable()
			   }
			   var elmt=publications.track.attach();
			   var sender=document.getElementById('sender');
		       sender.appendChild(elmt);
		   });
		   //Trigger the check Remote User function
		   checkRemoteUser();
		   setAccess(access => ({ ...access,localAvator:true}));
		   room.participants.forEach(participantConnected);
		   room.on('participantConnected',participantConnected);
		   room.on('participantDisconnected', participantConnected);
			   
		   //It trigger when room disconnected
		   room.once('disconnected', (room)=>{
			   removeLocalParticipant(room);
			   Socket.leaveCall(room.name);
			   setAccess({call:false,connect:false,end:false,isAudio:true,videoMute:true,remoteAudio:false,audioMute:false,completed:true});	   
		   });
	  });
  };
  
  /** 
  * To remove local participant
  * @room pass the Participant track details
  **/
  const removeLocalParticipant=(room)=>{
	 room.localParticipant.tracks.forEach((publication) => {
	   const attachedElements = publication.track.detach();		   
	   attachedElements.forEach((element) => element.remove());
	  });
  };
  
  /** 
  * To trigger the participant connected or disconnect
  * @participant pass the Participant stream details
  **/
  const participantConnected= (participant) => {
    var tracksDiv = document.getElementById('receiver');
	if(participant.state==='disconnected'){
		setJoin(true);
		setRoom(prevRoom => {
			prevRoom.disconnect();
			return prevRoom;
		});
	}else{
		setAccess(access => ({ ...access, remoteAvator:true }));
	}
	if(participant.videoTracks.size ===0){
		setAccess(access => ({ ...access, remoteAudio:true }));
	}
	participant.tracks.forEach((publication)  => {
		if (publication.isSubscribed) {
		  trackSubscribed(tracksDiv, publication.track);
		}
	  });
    participant.on('trackSubscribed', (track) => trackSubscribed(tracksDiv, track));
    participant.on('trackUnsubscribed',trackUnsubscribed);
	
  };
  
  /** Wait for Remote participant to join the call **/
  const checkRemoteUser=()=>{
     setTimeout(() => {
	  setRoom(prevRoom => {
		if (prevRoom.participants.size === 0 && prevRoom.state !=='disconnected') {
			setMissedCall(true);
		  Socket.closeIncomingCall({ receiver: props.id, room: prevRoom.name });
		  prevRoom.disconnect();
		}
		return prevRoom;
	  });
	}, 30000);

  }
  
  /** 
  * To add participant to stream to UI popup design
  * @div we pass the HTML div element for popup creation
  * @track we pass the participant audio and video tracks
  **/ 
   const trackSubscribed = (div, track) => {
	  const trackElement = track.attach();
	  div.append(trackElement);
	  track.on('enabled', (enabled:any) => {
		if(enabled.kind==='video'){
			setAccess(access => ({ ...access,remoteAvator:false}));
		}
		});
	  track.on('disabled', (disable:any) => {
		if(disable.kind==='video'){
			setAccess(access => ({ ...access,remoteAvator:true}));
		}
	   });
   };
  
  
    /** 
	* This function used To remove participant 
	* @track we get the participant track details
	**/  
   const trackUnsubscribed = (track) => {
	   
		  track.detach().forEach((element) => {
			element.remove()
		  });
    }
	
  /** To mute or Unmute video  **/
  const muteVideo=()=>{

     room.localParticipant.videoTracks.forEach((trackPublication:any) => {   
         !access.videoMute?trackPublication.track.disable():trackPublication.track.enable(); 
		 setAccess(access => ({ ...access,videoMute:!access.videoMute,localAvator:!access.localAvator}));
     });
  };
  
  /** To mute or Unmute voice  **/
  const muteVoice=()=>{
     room.localParticipant.audioTracks.forEach((trackPublication:any) => {
		 !access.audioMute?trackPublication.track.disable():trackPublication.track.enable(); 
		 setAccess(access => ({ ...access,audioMute:!access.audioMute}));
    })
  }

  
  return (
  <Modal 
	show={props.show} 
	onHide={closeModal}  
	backdrop="static"
    keyboard={false}
	size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
      <Modal.Header closeButton>
        <Modal.Title>Call Modal</Modal.Title>
      </Modal.Header>
      <Modal.Body>
	   <div className="row">
		<div className="col-xxl-12">
					<div className="patient-info">
						<div className="d-flex align-items-center">
							<div className="avtar-img">
							<span  className="rounded-circle">	
								<img  className="rounded-circle" src={props.photo==='default.png'?'/assets/img/user-avatar.png':convertS3privateToPublic(props.photo)} alt='logo' />
								 
								</span>
							</div>
							<div className="ms-3 pe-3">
								<p className="title">{props.name}</p>
								
							</div>
							
						</div>
					</div> 
		</div> 
		</div>
			<div className="row">
				<div className="col-12 row text-center">
				{access?.completed && !userEnd&& !missedCall && <h4 className="text-danger">{isJoin?'Call Ended':'User Busy'}</h4>}
				{access?.completed && userEnd&& <h4 className="text-danger">Call Ended</h4>}
				{access?.completed && missedCall&& <h4 className="text-danger">Call Missed</h4>}
				<div className={video?"col-6 position-relative":"col-6"} id="sender" >
				{access?.localAvator && video&& <img className="videoAvator rounded-circle w-50" src='/assets/img/user-avatar.png' alt='logo' />}
				{access.end && access.isAudio&& !video&& <div className="audioView"><img  className="rounded-circle w-50" src='/assets/img/user-avatar.png' alt='logo' /></div>}
				</div>
				<div className={access?.remoteAvator?"col-6 position-relative":"col-6"} id="receiver">
				{access?.remoteAvator && <img className="videoAvator rounded-circle w-50" src='/assets/img/user-avatar.png' alt='logo' />}
				{access?.remoteAudio && <div className="audioView"><img  className="rounded-circle w-50" src={props.photo==='default.png'?'/assets/img/user-avatar.png':convertS3privateToPublic(props.photo)} alt='logo' /></div>}
				</div>
				<div className="col-12">
                {access.call && <i style={{cursor: 'pointer'}} onClick={makeCall} className="fas fa-phone text-success fa-1x"> Call</i>}
				{access.connect && <h5>Connecting...</h5>}
				{access.end &&<i onClick={endCall} className="fas fas fa-phone text-danger fa-2x mx-2" style={{cursor: 'pointer',transform: 'rotate(135deg)'}}></i>}
				{access.end && <i onClick={muteVoice} className={access.audioMute?'fas fa-microphone-slash fa-2x mx-2':'fas fa-microphone fa-2x'}></i>}
                {access.end && <i onClick={muteVideo} className={access.videoMute?'fas fa-video-slash fa-2x mx-2':'fas fa-video fa-2x mx-2'}></i>}
				{isHold && <i className="fas fa-pause-circle fa-2x">&nbsp;&nbsp;&nbsp;</i>}
				</div>
               </div>
			</div>
	  </Modal.Body>
	  <Modal.Footer>
	   <Button variant="secondary" onClick={closeModal}>
          Close
        </Button>
	  </Modal.Footer>
	</Modal>
  );
}

export default OutgoingModal;
